import React from "react";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import TechPrepStaffBreadCrumbs from "../Layout/TechPrepStaffBreadCrumbs";

const SearchCoordinators = () => {
  const theme = useTheme();

  return (
    <Box sx={{ paddingTop: "100px" }}>
      {" "}
      {/* Add top padding to avoid header overlap */}
      <TechPrepStaffBreadCrumbs pageName="Search Coordinators" />
      <Box sx={{ padding: "20px" }}>
        <Typography
          variant="h4"
          component="h1"
          sx={{
            color: theme.palette.text.primary,
            marginBottom: "20px",
            textAlign: "center",
          }}
        >
          Search Coordinators
        </Typography>
        {/* Content will be added later */}
      </Box>
    </Box>
  );
};

export default SearchCoordinators;
